var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-container"},[_c('InsuranceCardFooter',{attrs:{"packages":_vm.packages,"testator":_vm.testator},on:{"cardExpanded":_vm.cardExpanded,"updateInsurance":params => _vm.$emit('updateInsurance', params)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }